'use strict';

const Headroom = require('headroom.js');

module.exports = function($) {
	var navOpen = false;
	var currentNavName = null;
	var previousNavName = null;
	var isChildNav = false;


	return {
		init: init
	};

	function init() {
		launchNav();
    stickyNav();
    stickyMapInput();
	}

	function stickyNav() {
		// grab an element
		var navigation = document.querySelector('header#primary');
		// construct an instance of Headroom, passing the element
		if (navigation !== null) {
      // if the element exists, initialise headroom
      var headroom  = new Headroom(navigation);
      headroom.init();
    }
  }

  function stickyMapInput() {
		// grab an element
		var inputEl = document.querySelector('.services__search');
		// construct an instance of Headroom, passing the element

		if (inputEl !== null) {
      var options = {
        offset: 120
      };
      // if the element exists, initialise headroom
      var headroom  = new Headroom(inputEl, options);
      headroom.init();
    }
	}


	function launchNav() {
		var navParent = $('[data-toggle-nav]');

		navParent.bind('click touchend', function(event) {
			var $this = $(this);
			var parent = $this;

			previousNavName = currentNavName;
			currentNavName = $this.data('toggle-nav');

			var nav = $('[data-nav="' + currentNavName + '"]');

			// close with esc key
			$this.bind('keydown keypress keyup', function (event) {
				if( event.which === 27 ) {
					closeNav(nav, parent);
					event.preventDefault();
				}
			});

			// flag for child nav
			if ( $this.parents('[data-nav]').length ) {
				isChildNav = true;
			}
			else {
				isChildNav = false;
			}

			// if there's a nav to open
			if (nav.length) {

				// open or close nav item
				if (previousNavName !== null && previousNavName === currentNavName && navOpen === true) {
					// close chosen nav on repeat click
					closeNav(nav, parent);
				}
				else {
					// open chosen nav
					openNav(nav, parent);
				}

				// close any open previous nav
				if (previousNavName !== null && previousNavName !== currentNavName) {

					var prevParent = $('[data-toggle-nav="' + previousNavName + '"]');
					var prevNav = $('[data-nav="' + previousNavName + '"]');

					if (prevNav.length && prevParent.length && previousNavName !== 'main') {
						closeNav(prevNav, prevParent);
					}
					// open chosen nav
					openNav(nav, parent);
				}

				if ( $this.attr('href') ) {
					event.preventDefault();
				}

				return false;
			}

		});
	}

	function openNav(nav, parent) {
		navOpen = true;

		parent.addClass('active');
		nav
			.removeClass('inactive')
			.addClass('active').focus();


		if ( currentNavName === 'search' ) {
			nav.find('input[type="text"]').focus();
		}
		if ( currentNavName === 'language' ) {
			$('body').addClass('show-nav-menu--language')
		}
		else {
			// set body scroll
			var scrollTop = ($('html').scrollTop()) ? $('html').scrollTop() : $('body').scrollTop();
			var bodyHeight = $('html').innerHeight();

			$('body')
				.addClass('freeze-body nav-menu-visible show-nav-menu--primary')
				.css('top', -scrollTop)
				.css('height', bodyHeight + 'px');
		}

		if (isChildNav) {
			parent.parents('nav').addClass('sub-nav-visible');
		}
	}

	function closeNav(nav, parent) {
		navOpen = false;

		parent
			.removeClass('active')
			.parents('nav')
				.removeClass('sub-nav-visible');

		nav
			.removeClass('active')
			.addClass('inactive');

		// set body scroll
		var scrollTop = parseInt($('body').css('top'));
		$('body')
			.removeClass('freeze-body nav-menu-visible show-nav-menu--language show-nav-menu--primary')
			.css('height', 'auto')
			.scrollTop(-scrollTop);
	}

};
